import { render, staticRenderFns } from "./PerfilSidebar.vue?vue&type=template&id=2733c286"
import script from "./PerfilSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./PerfilSidebar.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports